export default import.meta.ROLLDOWN_FILE_URL_t70prTw6q$NRQ55cjpIuqg